var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C1.79086 0 0 1.79086 0 4V28.7593C0 30.9684 1.79086 32.7593 4 32.7593H28C30.2091 32.7593 32 30.9684 32 28.7593V4C32 1.79086 30.2091 0 28 0Z",
    fill: "#117BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0543 12.728H8.74414V23.6798H12.0543V12.728Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3989 11.2938C10.7905 11.2974 11.1744 11.1819 11.5017 10.9618C11.829 10.7417 12.0851 10.4271 12.2374 10.0578C12.3898 9.68846 12.4315 9.28116 12.3572 8.88756C12.283 8.49395 12.0962 8.13179 11.8205 7.84705C11.5449 7.56231 11.1928 7.36782 10.8089 7.28828C10.4251 7.20873 10.0268 7.24771 9.66465 7.40027C9.30248 7.55283 8.99276 7.81209 8.77481 8.14514C8.55685 8.4782 8.44047 8.87002 8.44045 9.27089C8.43928 9.53535 8.489 9.79745 8.58679 10.0422C8.68458 10.287 8.82852 10.5097 9.01038 10.6975C9.19224 10.8854 9.40846 11.0347 9.6467 11.137C9.88495 11.2393 10.1406 11.2926 10.3989 11.2938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3446 17.9302C17.3446 16.3911 18.0405 15.4731 19.3655 15.4731C20.5834 15.4731 21.15 16.3546 21.15 17.9302V23.6755H24.4423V16.7428C24.4423 13.8107 22.8185 12.3904 20.5522 12.3904C19.906 12.3827 19.269 12.5471 18.7036 12.8673C18.1382 13.1876 17.6637 13.6527 17.3267 14.2172V12.7421H14.1504V23.7029H17.3267L17.3446 17.9302Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.fd69023983a276d7430df8b38d175513.svg";
export { ForwardRef as ReactComponent };